/** Densidade das linhas da listagem — "Tamanho da tabela" no protótipo. */
export type AuditDensity = "confortavel" | "compacto";

/**
 * Conteúdo opcional da listagem oferecido em "Mostrar e Ocultar Colunas".
 * A coluna Ação não entra na lista: ela identifica a linha e permanece sempre
 * visível; o que se pode ocultar é o par de valores exibido abaixo dela.
 */
export type AuditColumnKey =
  "dataHora" | "valorAnteriorNovo" | "justificativa" | "modulo" | "responsavel";

export interface AuditTableSettings {
  density: AuditDensity;
  columns: AuditColumnKey[];
}

export const DENSITY_OPTIONS: { value: AuditDensity; label: string; description: string }[] = [
  {
    value: "confortavel",
    label: "Confortável",
    description:
      "Exibe as linhas com mais espaçamento, facilitando a leitura e diminuindo a fadiga visual.",
  },
  {
    value: "compacto",
    label: "Compacto",
    description:
      "Reduz o espaçamento entre linhas para exibir mais registros simultaneamente por tela.",
  },
];

export const AUDIT_COLUMN_OPTIONS: { value: AuditColumnKey; label: string }[] = [
  { value: "dataHora", label: "Data/Hora" },
  { value: "valorAnteriorNovo", label: "Valor Anterior → Novo Valor" },
  { value: "justificativa", label: "Justificativa" },
  { value: "modulo", label: "Módulo" },
  { value: "responsavel", label: "Responsável" },
];

/** Estado inicial da listagem: tudo visível, na ordem do protótipo. */
export const ALL_AUDIT_COLUMNS: AuditColumnKey[] = AUDIT_COLUMN_OPTIONS.map(
  (option) => option.value,
);
